import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { wshColors } from './wshComponents'

// ─── Shared shell styled components ───────────────────────────────────────────
// Consumed by WshSupportModal, WshDemoModal, and any future WSH-branded modal.

export const WshModal = styled(Modal)`
  z-index: 1060;

  .modal-content {
    border: none;
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
    font-family: 'Inter', sans-serif;
  }
`

export const WshModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1059;
`

const WshModalHeaderInner = styled(Modal.Header)`
  background: linear-gradient(135deg, #1A2128, ${wshColors.primary}, ${wshColors.primaryLight});
  border: none;
  padding: 1rem 1.25rem;
  align-items: center;

  .btn-close {
    filter: brightness(0) invert(1);
    opacity: 0.7;
    &:hover { opacity: 1; }
  }
`

const WshModalLogo = styled.img`
  height: 24px;
  width: auto;
  filter: brightness(1.3);
  display: block;
`

const WshModalTagline = styled.div`
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.55);
  margin-top: 0.2rem;
`

interface WshModalHeaderProps {
  tagline: string
  closeButton?: boolean
}

export const WshModalHeader: React.FC<WshModalHeaderProps> = ({ tagline, closeButton = false }) => (
  <WshModalHeaderInner closeButton={closeButton}>
    <div>
      <WshModalLogo src="/wsh/wsh_logo_grn-landscape.png" alt="WholesaleHub" />
      <WshModalTagline>{tagline}</WshModalTagline>
    </div>
  </WshModalHeaderInner>
)

export const WshModalBody = styled(Modal.Body)`
  padding: 1.25rem;
  background: white;
`

export const WshModalFooter = styled(Modal.Footer)`
  background: white;
  border-top: 1px solid #e5e7eb;
  padding: 0.75rem 1.25rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`

export const WshFormGroup = styled.div`
  margin-bottom: 0.75rem;
`

export const WshFormLabel = styled.label`
  font-size: 0.85rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.4rem;
  display: block;
`

export const WshFormInput = styled.input`
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  padding: 0.55rem 0.75rem;
  font-size: 16px !important;
  font-family: 'Inter', sans-serif;
  color: #1f2937;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;

  &:focus { border-color: ${wshColors.primary}; }
  &::placeholder { color: #9ca3af; }
`

export const WshFieldError = styled.span`
  font-size: 0.78rem;
  color: #dc2626;
`

export const WshCancelBtn = styled.button`
  background: #f3f4f6;
  color: #374151;
  border: none;
  border-radius: 0.5rem;
  padding: 0.4rem 1rem;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: background 0.15s;

  &:hover:not(:disabled) { background: #e5e7eb; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`

export const WshSubmitBtn = styled.button`
  background: ${wshColors.primary};
  color: white;
  border: none;
  border-radius: 0.5rem;
  padding: 0.4rem 1rem;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  transition: background 0.15s;

  &:hover:not(:disabled) { background: ${wshColors.primaryLight}; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`
